export default function() {
	const self = this;

	self.notifications = ko.observableArray();

	self.onClick = function(notification, event) {
		if('function' === typeof notification.onClick()) {
			notification.close();
			notification.onClick()(event);
		}
	};

	self.showNotification = function(title, text, timeout) {
		timeout = isNaN(timeout) ? 10 : timeout;

		const notification = {
			title: title,
			text: text,
			isShow: ko.observable(false),
			onClick: ko.observable(),
			close: function () {
				notification.isShow(false);
				setTimeout(function() { self.notifications.remove(notification); }, 1000);
			}
		};

		self.notifications.push(notification);

		if(timeout > 0) {
			setTimeout(function () { notification.close(); }, parseInt(timeout) * 1000);
		}
		setTimeout(function() { notification.isShow(true); }, 0);

		return notification;
	};
};
